(() => {
  if (window.dupingdaoDirectCheckoutLoaded) return;
  window.dupingdaoDirectCheckoutLoaded = true;

  const selector = '[data-dupingdao-direct-checkout]';
  const initialized = new WeakSet();

  function controls(button) {
    const productForm = button.closest('product-form');
    const form = button.closest('form');
    return {
      productForm,
      form,
      addButton: form?.querySelector('button[name="add"]'),
      variantInput: form?.querySelector('[name="id"]'),
    };
  }

  function syncButton(button) {
    const { addButton, variantInput } = controls(button);
    button.disabled =
      !addButton ||
      addButton.disabled ||
      addButton.getAttribute('aria-disabled') === 'true' ||
      !variantInput ||
      variantInput.disabled ||
      !variantInput.value;
  }

  function initButtons() {
    document.querySelectorAll(selector).forEach((button) => {
      if (initialized.has(button)) return;
      initialized.add(button);
      const { addButton, variantInput } = controls(button);
      if (addButton) {
        new MutationObserver(() => syncButton(button)).observe(addButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
        });
      }
      if (variantInput) {
        new MutationObserver(() => syncButton(button)).observe(variantInput, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
        variantInput.addEventListener('change', () => syncButton(button));
      }
      syncButton(button);
    });
  }

  function showError(productForm, message) {
    if (typeof productForm?.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(message);
      return;
    }
    const wrapper = productForm?.querySelector('.product-form__error-message-wrapper');
    const text = wrapper?.querySelector('.product-form__error-message');
    if (wrapper && !message) {
      wrapper.hidden = true;
      return;
    }
    if (text) {
      text.textContent = message || window.cartStrings?.error || 'Checkout unavailable';
      wrapper.hidden = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(selector);
    if (!button || button.disabled || button.dataset.loading === 'true') return;

    const { productForm, form, addButton, variantInput } = controls(button);
    if (!form || !addButton || !variantInput || addButton.disabled || variantInput.disabled || !variantInput.value) {
      syncButton(button);
      return;
    }

    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    showError(productForm, false);

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || window.cartStrings?.error);
      }
      const root = (button.dataset.rootUrl || '/').replace(/\/?$/, '/');
      window.location.assign(root + 'checkout');
    } catch (error) {
      showError(productForm, error.message || window.cartStrings?.error);
      button.dataset.loading = 'false';
      button.removeAttribute('aria-busy');
      syncButton(button);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons, { once: true });
  } else {
    initButtons();
  }
  document.addEventListener('product-info:loaded', initButtons);
  document.addEventListener('shopify:section:load', initButtons);
})();
